import { Injectable } from '@angular/core';
import * as _ from 'lodash';

@Injectable()
export class LMUniqueIdService {

  private idIndex = 0;
  private idPrefix = 'lm-id-';
  private ids = [];
  private compIndex = 0;

  // DO NOT add other LM services due to the possibility of circular references
  constructor() {}

  // it is up to the caller to determine what information is required to create a unique id
  // array items are set in the order to appear in the id
  // null, undefined, or empty string items are not included in the final id
  // safety: if all items resolve to an empty string, return lm-id
  public uniqueId(items: Array<string>): string {
    const id = items && items.filter( item => {
      if (item && _.trim(item).length > 0) {
        return true;
      }
    }).join('_');

    return (id && id.length > 0) ? id : (this.idPrefix + this.idIndex++);
  }

  public uniqueAutomationId(items: Array<string>): string {
    const id = items && items.filter( item => {
      if (item && _.trim(item).length > 0) {
        return true;
      }
    }).join('-');

    return (id && id.length > 0) ? id : (this.idPrefix + this.idIndex++);
  }

  public getUniqueId(): string {
    const id = Math.round(Math.random() * 99999 | 0).toString();

    if (this.ids.includes(id)) {
      this.getUniqueId();
    }

    this.ids.push(id);
    return id;
  }

  public getCompIndex() : number {
    return this.compIndex++;
  }
}
